import {GET_USER_DATA_FAILED, GET_USER_DATA_IN_PROGRESS, GET_USER_DATA_SUCCESSFUL} from "../action/action-types";

let initialState = {
    inProgress: false,
    startUpFailed: false,
    successful: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_USER_DATA_FAILED:
            return {...state, startUpFailed: true, successful: false, inProgress: false};
        case GET_USER_DATA_SUCCESSFUL:
            return {...state, startUpFailed: false, successful: true, inProgress: false};
        case GET_USER_DATA_IN_PROGRESS:
            return {...state, inProgress: true};
        default:
            return state;
    }
}